import script from "./UpdateRequiredView.vue?vue&type=script&setup=true&lang=js"
export * from "./UpdateRequiredView.vue?vue&type=script&setup=true&lang=js"

import "./UpdateRequiredView.vue?vue&type=style&index=0&id=25cd53c8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-25cd53c8"]])

export default __exports__